import {Inject, Injectable} from '@angular/core';
import {LOCAL_STORAGE, StorageService} from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor(@Inject(LOCAL_STORAGE) private storage: StorageService) {
  }

  get = (key: string) => {
    return this.storage.get(key);
  };
  set = (key: string, value: any): void => {
    this.storage.set(key, value);
  };
  remove = (key: string): void => {
    this.storage.remove(key);
  };
  removeMultiple = (keys: string[]): void => {
    keys.forEach((value) => this.remove(value));
  };
  clear = (): void => {
    this.storage.clear();
  };
}
